import { connect } from 'react-redux';

import { Creators as userActions } from 'Reducers/user';
import { Creators as transientActions } from 'Reducers/transient';

import AdvancedFilters from './view';

export default connect(
  state => ({
    ...state.transient,
    role: state.user.role_name,
    view: state.adminDailyFigures.view,
    adminFilters: state.user.adminFilters,
    userAdminFilters: state.user.admin_filters,
    history: state.application.routing.history
  }),
  {
    updateTransientProps: transientActions.updateProps,
    updateUser: userActions.updateApiModel,
    updateUserProps: userActions.updateProps
  }
)(AdvancedFilters);
